var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const jsonRegExp = /^{[\s\S]*[\r\n]*}/;
const terminators = ['\r', '\n'];
export class AtlonaMs52w {
    // other class properties and constructor
    constructor(socket, state, log, framework) {
        this.socket = socket;
        this.state = state;
        this.muteChannel = 'hdmi';
        // controls
        this.busy = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                return this.state.busy.value;
            }),
        };
        this.firmwareVersion = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const resp = (yield this.socket.send(`Misc:Versions:Get`, (resp) => {
                    var _a;
                    const rcvd = (_a = resp.methodreturn) !== null && _a !== void 0 ? _a : '';
                    return rcvd.toLowerCase().includes('misc:versions:get') ? resp : undefined;
                }, tags));
                return (_c = (_b = (_a = resp.result) === null || _a === void 0 ? void 0 : _a.version) === null || _b === void 0 ? void 0 : _b.master) !== null && _c !== void 0 ? _c : 'unknown';
            }),
        };
        this.videoMatrixRoutes = {
            get: (key, tags) => __awaiter(this, void 0, void 0, function* () {
                var _d;
                const resp = (yield this.socket.send(`Display:Matrix:Get ${key}`, (resp) => {
                    var _a;
                    const rcvd = (_a = resp.methodreturn) !== null && _a !== void 0 ? _a : '';
                    return rcvd.toLowerCase().includes('display:matrix:get') ? resp : undefined;
                }, tags));
                const input = (_d = resp === null || resp === void 0 ? void 0 : resp.result.input) !== null && _d !== void 0 ? _d : -1;
                return input >= 0 ? input.toString() : this.state.videoMatrixRoutes.values[key];
            }),
            set: (key, value, tags) => __awaiter(this, void 0, void 0, function* () {
                var _e;
                const resp = (yield this.socket.send(`Display:Matrix:Set ${value} ${key}`, (resp) => {
                    var _a;
                    const rcvd = (_a = resp.methodreturn) !== null && _a !== void 0 ? _a : '';
                    return rcvd.toLowerCase().includes('display:matrix:set') ? resp : undefined;
                }, tags));
                const success = (_e = resp.result.success) !== null && _e !== void 0 ? _e : false;
                return success ? value : this.state.videoMatrixRoutes.values[key];
            }),
        };
        this.volume = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                var _f, _g;
                const resp = (yield this.socket.send(`Audio:Volume:Get`, (resp) => {
                    var _a;
                    const rcvd = (_a = resp.methodreturn) !== null && _a !== void 0 ? _a : '';
                    return rcvd.toLowerCase().includes('audio:volume:get') ? resp : undefined;
                }, tags));
                return (_g = (_f = resp.result.volume) === null || _f === void 0 ? void 0 : _f.value) !== null && _g !== void 0 ? _g : this.state.volume.value;
            }),
            set: (volume, tags) => __awaiter(this, void 0, void 0, function* () {
                var _h;
                const resp = (yield this.socket.send(`Audio:Volume:Set ${volume}`, (resp) => {
                    var _a;
                    const rcvd = (_a = resp.methodreturn) !== null && _a !== void 0 ? _a : '';
                    return rcvd.toLowerCase().includes('audio:volume:set') ? resp : undefined;
                }, tags));
                const success = (_h = resp.result.success) !== null && _h !== void 0 ? _h : false;
                return success ? volume : this.state.volume.value;
            }),
            range: { max: 0, min: -50, round: 1 }, // full volume range is 0 to -80
        };
        this.volumeMute = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                var _j, _k;
                const resp = (yield this.socket.send(`Audio:Mute:Get`, (resp) => {
                    var _a;
                    const rcvd = (_a = resp.methodreturn) !== null && _a !== void 0 ? _a : '';
                    return rcvd.toLowerCase().includes('audio:mute:get') ? resp : undefined;
                }, tags));
                const muteValue = this.muteChannel === 'hdmi'
                    ? (_j = resp.result.outputmute) === null || _j === void 0 ? void 0 : _j.hdmi
                    : (_k = resp.result.outputmute) === null || _k === void 0 ? void 0 : _k.analog;
                return muteValue ? muteValue : this.state.volumeMute.value;
            }),
            set: (mute, tags) => __awaiter(this, void 0, void 0, function* () {
                var _l;
                const resp = (yield this.socket.send(`Audio:Mute:Set ${this.muteChannel} ${mute ? 'true' : 'false'}`, (resp) => {
                    var _a;
                    const rcvd = (_a = resp.methodreturn) !== null && _a !== void 0 ? _a : '';
                    return rcvd.toLowerCase().includes('audio:mute:set') ? resp : undefined;
                }, tags));
                const success = (_l = resp === null || resp === void 0 ? void 0 : resp.result.success) !== null && _l !== void 0 ? _l : false;
                return success ? mute : this.state.volumeMute.value;
            }),
        };
        // polling
        this.polls = [{ intervalMs: 4500, controls: ['videoMatrixRoutes'] }];
    }
    // phase callbacks
    onConfigure() {
        return __awaiter(this, void 0, void 0, function* () {
            // Set compact JSON command response mode.
            yield this.socket.send('OutputMode j', (resp) => {
                return resp;
            }, ['set.outputMode']);
        });
    }
    onInitialize(credentials) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const resp = (yield this.socket.send(`Display:Matrix:Get 0`, (resp) => {
                var _a;
                const rcvd = (_a = resp.methodreturn) !== null && _a !== void 0 ? _a : '';
                return rcvd.toLowerCase().includes('display:matrix:get') ? resp : undefined;
            }, ['get.videoMatrixRoutes', 'get.onInitialize']));
            const input = (_a = resp.result.input) !== null && _a !== void 0 ? _a : -1;
            return input >= 0 ? 'connected' : 'verifyFailed';
        });
    }
}
// static properties
AtlonaMs52w.driverType = 'socketDriver';
AtlonaMs52w.key = '-MOYEkDkF7gnN31t-hcE';
AtlonaMs52w.baseSocketOptions = {
    commandExtractor: (buffer) => {
        let n = 0;
        while (n < buffer.length && terminators.includes(buffer[n]))
            n++;
        buffer = buffer.slice(n);
        if (buffer.length === 0)
            return undefined;
        n = 0;
        if (buffer[n] === '{') {
            const match = jsonRegExp.exec(buffer);
            if (match === null)
                return undefined;
            buffer = buffer.substr(match[0].length);
            return { command: match[0], buffer };
        }
        while (n < buffer.length && !terminators.includes(buffer[n]))
            n++;
        if (n >= buffer.length)
            return undefined;
        return { command: buffer.slice(0, n), buffer: buffer.substr(n) };
    },
    parser: (command) => {
        try {
            const resp = JSON.parse(command);
            return resp;
        }
        catch (err) {
            return undefined;
        }
    },
    sendTerminator: '\r',
};
AtlonaMs52w.socketOptions = [
    Object.assign(Object.assign({}, AtlonaMs52w.baseSocketOptions), { port: 23 }),
    Object.assign(Object.assign({}, AtlonaMs52w.baseSocketOptions), { port: 4999 }),
];
